import { AGES, CONVERSION_BEHAVIOR, EXCLUDED_DAY } from '@/views/create/gdt/model/targeting-const.js'
import { MANUAL_SITES, EXPLORATION_ENUM } from '@/views/create/gdt/model/siteset/siteset-const.js'
import { AD_MARKETING_SCENE } from '@/views/create/gdt/model/project-const'
export const getGdtv3TargetingForm = (account) => {
  const populations = {}
  if (account?.id) {
    populations[account.id] = {
      accountId: account.id,
      includes: [],
      excludes: []
    }
  }

  return {
    ...getTargetingSiteSetFields(),
    name: '',
    audienceType: 0, // 人群包类型
    regionType: 0,
    region: [], // 地域
    locationTypes: ['LIVE_IN'],
    gender: 0, // 性别
    age: 0, // 年龄
    network: [0], // 网络
    game_consumption_level: [0], // 游戏用户消费能力
    wechatAdBehaviorType: [0], // 微信再营销
    wechatAdBehavior: {
      actions: [], // 微信再营销包含行为列表
      excluded_actions: [], // 微信再营销排除行为列表
      mini_game_wechat_registered_activity: 'THIRTY_DAYS_NO_ACTIVE' // 已注册小游戏未活跃天数
    },
    ageRange: [19, 25], // 自定义年龄段
    deviceType: 0, // 手机品牌类型
    device: [], // 手机品牌
    excludeDevice: false, // 排除所选设备
    osType: 0,
    version: [], // 系统版本
    devicePrice: [0], // 设备价格

    // 排除已转化用户
    excludeCustom: false,
    excluded_converted_audience: {
      excluded_dimension: 0,
      conversion_behavior_list: [CONVERSION_BEHAVIOR.APP_ACTIVATE],
      excluded_day: EXCLUDED_DAY.ONE_MONTH
    },
    populations, // 人群包
    searchAdBidKeywords: [] // 搜索广告关键词
  }
}

/**
 * @description: 版位相关字段
 * @return {*}
 */
function getTargetingSiteSetFields() {
  return {
    automatic_site_enabled: false, // 手动版位
    siteSet: MANUAL_SITES,

    ad_marketing_scene: AD_MARKETING_SCENE.VERSION_3,

    smart_targeting_mode: false, // 定向模式：false=智能定向，true=手动定向(SMART_TARGETING_MANUAL)

    exploration_strategy: EXPLORATION_ENUM.AUTOMATIC,
    priority_site_set: MANUAL_SITES,

    // 微信公众号与小程序定投
    wechat_position: 0,
    wechatPostion: [],
    // 微信视频号定投
    wechat_channels: 0,
    wechatChannels: [],
    // 微信公众号与小程序场景
    wechat_scene: 0,
    // 公众号媒体类型
    officialAccountMediaCate: [],
    miniGame: [], // 小程序小游戏流量 checkbox model
    payScene: [], // 订单详情页消费场景 checkbox model

    pc_scene: 0,
    pcScene: [], // 腾讯广告电脑端定投 checkbox model

    qbsearch_scene: 0,
    qbSearchScene: [], // QQ浏览器等流量场景 checkbox model

    wechat_search_scene: 0,
    wechatSearchScene: [], // 微信搜一搜流量场景 checkbox model

    // 优量汇场景
    displaySceneType: 0, // 优量汇广告展示场景
    includeUnionType: 0, // 优量汇流量包定投
    excludeUnionType: 0, // 优量汇流量包屏蔽
    flow_optimization_enabled: false, // 优量汇自动流量优选
    scene_spec: {
      display_scene: [],
      // 分帐号保存的已选优量汇流量包屏蔽包
      // {account_id: 0, excludePackages: []}
      exclude_union_position_package: {},
      include_union_position_package: {}
    }
  }
}
